'use strict';exports.__esModule = true;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _simplifyJs = require('simplify-js');var _simplifyJs2 = _interopRequireDefault(_simplifyJs);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _intersection = require('lodash/intersection');var _intersection2 = _interopRequireDefault(_intersection);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _throttle = require('lodash/throttle');var _throttle2 = _interopRequireDefault(_throttle);
var _constants = require('../constants');








var _scriptLoaders = require('./scriptLoaders');
var _createCustomMapPin = require('../utils/createCustomMapPin');var _createCustomMapPin2 = _interopRequireDefault(_createCustomMapPin);
var _checkUserAgent = require('../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _slugify = require('../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _createCustomGoogleInfoWindow = require('../utils/createCustomGoogleInfoWindow');
var _markerclusterer = require('../../static/scripts/markerclusterer.min');var _markerclusterer2 = _interopRequireDefault(_markerclusterer);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

GoogleService = function () {

























  function GoogleService(locale, done) {var _this = this;_classCallCheck(this, GoogleService);_initialiseProps.call(this);
    if (global.google && global.google.places && this.locale === locale) {

      done(this);
    } else {
      (0, _scriptLoaders.googleSDKLoader)(locale).
      then(function (google) {
        _this.loaded = true;
        _this.locale = locale;

        // Encapsulate the SDK on the instance
        _this.google = google;
      }).
      then(function () {return _this.initialise();}).
      then(function () {return done(_this);}).
      catch(this.handleError);
    }
  }GoogleService.prototype.

  initialise = function initialise() {
    var maps = this.google.maps;var
    places = maps.places,geometry = maps.geometry;

    maps.CustomWindow = (0, _createCustomGoogleInfoWindow.createCustomInfoWindow)(maps);

    this.userAgentIsFirefox = _checkUserAgent2.default.isFirefox(navigator.userAgent);
    this.userAgentIsIE = _checkUserAgent2.default.isInternetExplorer(navigator.userAgent);
    this.OK = {
      place: places.PlacesServiceStatus.OK,
      geocode: maps.GeocoderStatus.OK };

    this.autocompleteService = new places.AutocompleteService();
    this.SessionToken = places.AutocompleteSessionToken;
    this.LatLngBounds = maps.LatLngBounds;
    this.Coordinate = maps.LatLng;
    this.Map = maps.Map;
    this.InfoWindow = maps.CustomWindow;
    this.Marker = maps.Marker;
    this.Polygon = maps.Polygon;
    this.Point = maps.Point;
    this.position = maps.ControlPosition;
    this.clearListeners = maps.event.clearListeners;
    this.event = maps.event;
    this.trigger = maps.event.trigger;
    this.animation = maps.Animation;
    this.computeHeading = geometry.spherical.computeHeading;
    this.maxZIndex = 10000;
    this.Size = maps.Size;
    this.containsLocation = geometry.poly.containsLocation;
    this.MarkerClusterer = _markerclusterer2.default; // global.MarkerClusterer || window.MarkerClusterer;
  };












  // TODO: Move geocode to Locus



















































































































































































  // PUBLIC













  // PUBLIC

















































































  // TODO: It looks like unnecessary wrapper of performGeocodeLocusByInnerBase





















  // TODO: It's duplicate autocompleteLocusViaGoogle
  // TODO: Check tests
  // autocomplete = input => ((input)
  //     ? new Promise((resolve, reject) =>
  //       axios.get(`${locationsApiURL}/places/autocomplete?query=${input}`)
  //         .then(({ data }) => resolve(data))
  //         .catch(reject)
  //     )
  //     : Promise.resolve([])
  // );























































  // TODO: It's fallback if Locus will be unhealthy
















































  // eslint-disable-next-line






















































































































































































































































































  /* eslint-disable id-length */














  /* eslint-enable id-length */















































  // Viewport to zoom calculation -> adapted from http://stackoverflow.com/q/6048975
  return GoogleService;}();GoogleService.SUPPORTED_LANGS = _constants.language.languages;GoogleService.REQUIRED_ADDRESS_PARTS = ['country_name', 'city_name', 'house_number', 'street_name', 'neighborhood', 'location', 'post_code', 'formatted'];GoogleService.OPTIONS = { // TODO temp
  // defaultCountry: 'Israel',
  componentRestrictions: { country: _constants.googleSdkConfig.restrictionCountry }, types: ['geocode'] };GoogleService.options = { geocode: { defaultCountry: 'Israel' }, zooms: { city: 12, neighborhood: 16, street: 16, full_address: 20 } };GoogleService.formatLegacyGoogleResponse = function (response) {var result = {};Object.keys(response.addresses).forEach(function (locale) {var _response$addresses$l = response.addresses[locale].parts,post_code = _response$addresses$l.post_code,parts = _objectWithoutProperties(_response$addresses$l, ['post_code']);result[locale] = Object.assign({}, parts, { formatted: response.addresses[locale].address });});result.key = response.key;result.tags = response.tags;result.location = response.location || null;result.google_place_id = response.extra && response.extra.google_place_id;result.isCity = response.address_type === 'city';result.isNeighborhood = response.address_type === 'neighborhood';result.isFull = response.isFull || response.address_type === 'full_address';result.zoom = GoogleService.options.zooms[response.address_type];result.map = {};result.place_id = response.id;if (response.polygon) {// TODO: Strip it down
    result.polygon = response.polygon;}return result;};GoogleService.





















constructStaticMapLink = function (locale, centerPoint, pins, _ref) {var _ref$width = _ref.width,width = _ref$width === undefined ? 860 : _ref$width,_ref$height = _ref.height,height = _ref$height === undefined ? 500 : _ref$height,_ref$scale = _ref.scale,scale = _ref$scale === undefined ? 1 : _ref$scale;var zoom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 15;var
  lat = centerPoint.lat,lon = centerPoint.lon;

  var markers = pins.length ?
  pins.reduce(function (acc, pin) {
    acc += '|' + pin;
    return acc;
  }, '') :
  undefined;

  var center = pins.length ? undefined : lat + ',' + lon;

  var config = {
    language: locale,
    center: center,
    zoom: pins.length > 1 ? undefined : zoom,
    size: width + 'x' + height,
    scale: scale,
    markers: markers && 'icon:' + _constants.googleSdkConfig.staticMapPin + markers };


  var params = Object.keys(config).reduce(function (acc, key) {
    var param = config[key] ? key + '=' + config[key] + '&' : '';
    acc += param;
    return acc;
  }, '');

  return _constants.googleSdkConfig.staticMapUrl + '?' + params + '&key=' + _constants.googleSdkConfig.apiKey;
};GoogleService.

constructStreetViewPhotoLink =
function (lat, lng) {var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.imageConfig.thumbnailSize.width;var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.imageConfig.thumbnailSize.height;
  var params = 'size=' + width + 'x' + height + '&location=' + lat + ',' + lng + '&pitch=10&fov=120';
  return _constants.googleSdkConfig.streetViewPhotoUrl + '?' + params + '&key=' + _constants.googleSdkConfig.apiKey;
};var _initialiseProps = function _initialiseProps() {var _this2 = this;this.loaded = false;this.google = null;this.locale = null;this.cleanup = function () {(0, _createCustomMapPin.clearMemoizedPins)();};this.createSessionToken = function () {return new _this2.SessionToken();};this.googleServiceRun = function (googleFunction) {for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {args[_key - 1] = arguments[_key];}return _this2.loaded ? Promise.resolve(googleFunction.apply(undefined, args)) : _this2.handleError(new Error('Attempted to use Google function before library has loaded')) || Promise.resolve();};this.geocode = function (placeId, address, map) {var country = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : GoogleService.options.geocode.defaultCountry;var locality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';var latLng = arguments[5];if (!placeId && !address && !latLng) {return Promise.reject(new Error('Invalid arguments for geocode. Provide place ID or address'));}var separator = country ? ', ' : '';var baseParam = placeId ? 'place_id=' + placeId : 'address=' + address + separator + country;var base = latLng ? 'latlng=' + latLng.lat + ',' + latLng.lng : baseParam;var fullUrl = _constants.googleSdkConfig.geocodeUrl + '?' + base + '&key=' + _constants.googleSdkConfig.apiKey + '&language=';var geocodePromises = GoogleService.SUPPORTED_LANGS.map(function (locale) {return _axios2.default.get(fullUrl + locale);});return Promise.all(geocodePromises).then(function (results) {return results.map(function (_ref2) {var _ref3;var _ref2$data$results = _ref2.data.results,suggestion = _ref2$data$results[0],url = _ref2.config.url;return _ref3 = {}, _ref3[url.slice(-2)] = suggestion, _ref3;});}).then(function (localised) {// Merge in one object
      var result = {};for (var _iterator = localised, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref4;if (_isArray) {if (_i >= _iterator.length) break;_ref4 = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref4 = _i.value;}var info = _ref4;result = Object.assign({}, result, info);}var notEmpty = true;for (var _iterator2 = Object.keys(result), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {var _ref5;if (_isArray2) {if (_i2 >= _iterator2.length) break;_ref5 = _iterator2[_i2++];} else {_i2 = _iterator2.next();if (_i2.done) break;_ref5 = _i2.value;}var locale = _ref5;notEmpty = notEmpty && !!result[locale];}if (!notEmpty) {throw new Error('No results.');}return result;}).then(function (geocoded) {// Format the addresses
      var result = { isFull: true, isCity: true, isNeighborhood: true };var cleanupKeys = ['location', 'post_code', 'google_place_id', 'isFull', 'isCity', 'isNeighborhood', 'viewport'];for (var _iterator3 = Object.keys(geocoded), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {var _ref6;if (_isArray3) {if (_i3 >= _iterator3.length) break;_ref6 = _iterator3[_i3++];} else {_i3 = _iterator3.next();if (_i3.done) break;_ref6 = _i3.value;}var locale = _ref6;result[locale] = _this2.formatAddress(geocoded[locale], false, locality, locale);result.location = result[locale].location;result.map = result[locale].viewport;result.google_place_id = result[locale].google_place_id; // If components are incomplete, then the general object is the same
        result.isFull = result.isFull && result[locale].isFull;result.isCity = result.isCity && result[locale].isCity;result.isNeighborhood = result.isNeighborhood && result[locale].isNeighborhood;result[locale] = (0, _omit2.default)(result[locale], cleanupKeys);}for (var _iterator4 = _constants.language.ignoredLanguages, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {var _ref7;if (_isArray4) {if (_i4 >= _iterator4.length) break;_ref7 = _iterator4[_i4++];} else {_i4 = _iterator4.next();if (_i4.done) break;_ref7 = _i4.value;}var ignoreLocale = _ref7;result[ignoreLocale] = null;}result.isFull = !!result.isFull;result.isCity = !!result.isCity;result.isNeighborhood = !!result.isNeighborhood;result.location = { lon: result.location.lng, lat: result.location.lat };result.map = { topright: { lat: result.map.northeast.lat, lon: result.map.northeast.lng }, bottomleft: { lat: result.map.southwest.lat, lon: result.map.southwest.lng } };result.zoom = map ? _this2.getZoomByViewport(result.map.bottomleft, result.map.topright, map.width, map.height) || map.getZoom() : null;return result;}).catch(_this2.handleError);};this.handleError = function (err) {// Avoid logging server side load script error
    if (err.message === 'ZERO_RESULTS' || err.message === 'No results.') {console.log('No results');} else if (!err.code || err.code !== 'SSR') {console.error('Google SDK error:', err);}};this.formatAddress = function (_ref8) {var _ref8$geometry = _ref8.geometry,location = _ref8$geometry.location,viewport = _ref8$geometry.viewport,components = _ref8.address_components,formatted = _ref8.formatted_address,id = _ref8.place_id;var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var locality = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';var locale = arguments[3];var address = { location: location, formatted: formatted };for (var _iterator5 = components, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {var _ref9;if (_isArray5) {if (_i5 >= _iterator5.length) break;_ref9 = _iterator5[_i5++];} else {_i5 = _iterator5.next();if (_i5.done) break;_ref9 = _i5.value;}var component = _ref9;var key = null;switch (component.types[0]) {case 'country':{key = 'country_name';break;}case 'postal_town':case 'locality':{key = 'city_name';break;}case 'neighborhood':{key = 'neighborhood';break;}case 'street_number':{key = 'house_number';break;}case 'route':case 'street_address':{key = 'street_name';component.long_name = component.long_name.replace(/Street/i, 'St.');break;}case 'administrative_area_level_1':{key = 'country_region';break;}case 'postal_code':{key = 'post_code';break;}case 'administrative_area_level_2':{key = 'city_region';break;}default:key = component.types[0];}address[key] = component.long_name.replace(/'/g, '');} // Check extra data
    if (!address.neighborhood && address.city_name) {address.neighborhood = address.city_name;}if (!address.city_name && locality) {address.city_name = locality;}if (!address.country_name) {address.country_name = _constants.israelTranslations[locale];}var result = full ? address : (0, _pick2.default)(address, GoogleService.REQUIRED_ADDRESS_PARTS);var allPresentKeys = Object.keys(result);var requiredPresentKeys = (0, _intersection2.default)(allPresentKeys, GoogleService.REQUIRED_ADDRESS_PARTS);if (requiredPresentKeys.length >= GoogleService.REQUIRED_ADDRESS_PARTS.length - 1) {result.isFull = true;}result.isCity = requiredPresentKeys.length === 4 && address.city_name || requiredPresentKeys.length === 5 && address.city_name === address.neighborhood;result.isNeighborhood = requiredPresentKeys.length === 5 && address.neighborhood && address.city_name !== address.neighborhood;result.viewport = viewport;result.google_place_id = id;return result;};this.getTypeByTagsLength = function () {var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;return ['city', 'street', 'full_address'][length - 1];};this.searchLocusByTags = function (tags, type) {var latlng = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var lat = latlng.lat,lon = latlng.lng;return _axios2.default.get(_constants.locationsApiURL + '/places/geocode', { params: { address_type: type || _this2.getTypeByTagsLength(tags.length), tags: tags.map(function (t) {return t.replace(/\./g, '');}), lat: lat, lon: lon, full: true } });};this.performSearchLocusViaGoogle = function (id, lat, lon, address, country) {return _axios2.default.get(_constants.locationsApiURL + '/places/google', { params: { google_place_id: id, lat: lat, lon: lon, address: address, country: country } });};this.geocodeByCoordinate = function (latLng, overseas_only) {if (overseas_only) {return _this2.geocodeLocusViaGoogle(null, null, latLng);}return _this2.geocodeLocusViaInternalBase(null, null, null, null, latLng);};this.geocodeCountryByAddress = function (address) {var country = 'all';return _this2.geocodeLocusViaGoogle(null, null, null, address, country);};this.performGeocodeLocusByInnerBase = function (tags, address, type) {var latlng = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};return new Promise(function (resolve, reject) {return _this2.searchLocusByTags(tags || [], type, latlng).then(function (res) {if (!res || !res.data) {throw new Error('No result');}resolve(GoogleService.formatLegacyGoogleResponse(res.data));}).catch(function (err) {if (!address && !latlng.lat) {return resolve(null);}return resolve(_this2.googleServiceRun(_this2.geocode, null, address, null, null, null, latlng));});});};this.geocodeLocusViaGoogle = function (placeId, locality, latlng, address, country) {return new Promise(function (resolve, reject) {var coordinates = latlng || {};var lat = coordinates.lat,lng = coordinates.lng;_this2.performSearchLocusViaGoogle(placeId, lat, lng, address, country).then(function (res) {if (!res || !res.data) {throw new Error('No result');}resolve(GoogleService.formatLegacyGoogleResponse(res.data));}).catch(function (err) {// eslint-disable-next-line
        var id = void 0,map = void 0;return resolve(_this2.googleServiceRun(_this2.geocode, id, address, map, country, locality, latlng));});});};this.geocodeLocusViaInternalBase = function (address, tags, locality, country) {var latlng = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};var lat = latlng.lat,lon = latlng.lng; // eslint-disable-next-line
    var map = void 0;var hasTags = tags && tags.length;var hasCoords = lat && lon; // eslint-disable-next-line no-nested-ternary
    return hasTags || hasCoords ? _this2.performGeocodeLocusByInnerBase(tags, address, null, latlng) : address || country ? _this2.geocodeLocusViaGoogle(null, null, null, address, country || 'all') : _this2.googleServiceRun(_this2.geocode, null, address, map, country, locality, hasCoords ? latlng : null);};this.autocompleteLocusViaInternalBase = function (query, tags, type) {var locusSearchConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};return query ? new Promise(function (resolve, reject) {return _axios2.default.get(_constants.locationsApiURL + '/address/autocomplete', { params: { query: query, tags: tags, type: type, full: true } }).then(function (_ref10) {var data = _ref10.data;var predictions = data.predictions;predictions.forEach(function (item) {if (type) {item.description = (0, _get2.default)(item, 'parts.' + (type === 'street' ? 'street_name' : 'city_name'), '');} else {item.description = (0, _get2.default)(item, 'address');}});resolve(predictions);}).catch(reject);}) : Promise.resolve([]);};this.autocompleteLocusViaGoogle = function (query, types) {var locusSearchConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};return query ? new Promise(function (resolve, reject) {return _axios2.default.get(_constants.locationsApiURL + '/places/autocomplete', { params: { query: query, types: types, overseas_only: locusSearchConfig.overseasOnly, country: locusSearchConfig.country, locale: locusSearchConfig.locale } }).then(function (_ref11) {var data = _ref11.data;if (data.length) {resolve(data);} else {reject();}}).catch(reject);}) : Promise.resolve([]);};this.autocompleteLocus = function (query, tags, type) {var locusSearchConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};if (locusSearchConfig.overseasOnly) {return _this2.autocompleteLocusViaGoogle(query, type, locusSearchConfig);}return _this2.autocompleteLocusViaInternalBase(query, tags, type, locusSearchConfig);};this.autocompleteGoogle = function (input) {var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GoogleService.OPTIONS.types;var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};return input ? new Promise(function (resolve, reject) {return _this2.autocompleteService.getPlacePredictions(Object.assign({ input: input }, GoogleService.OPTIONS, { types: types }, options), function (results, status) {return status === _this2.OK.place ? resolve(results) : reject(new Error(status));});}) : Promise.resolve([]);};this.createAddressInLocus = function (addressData, access_token) {var city = (0, _get2.default)(addressData, 'en.city_name');var street = (0, _get2.default)(addressData, 'en.street_name');var house_number = (0, _get2.default)(addressData, 'en.house_number');var location = addressData.location;var tags = addressData.tags ? addressData.tags.slice(0, 2) : [(0, _slugify2.default)(city), (0, _slugify2.default)(street)];var requestData = { tags: tags, address_parts: { house_number: house_number }, location: location };return new Promise(function (resolve, reject) {return _axios2.default.post(_constants.locationsApiURL + '/places/full-by-user', requestData, { headers: { access_token: access_token } }).then(function (_ref12) {var data = _ref12.data;return resolve(data);}).catch(reject);});};this.createMapInstance = function (mapContainer, options) {return new _this2.Map(mapContainer, options);};this.createInfoWindow = function (content) {var propertyInfoWindow = new _this2.InfoWindow({ disableAutoPan: true });propertyInfoWindow.setContent(content);return propertyInfoWindow;};this.createPin = function (lat, lng) {var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};var scaledSizeParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [20, 20];return new _this2.Marker(Object.assign({}, data, { position: { lat: lat, lng: lng }, icon: { url: (0, _createCustomMapPin2.default)(data.number || 0, data.type, false, data.reviewed), scaledSize: new (Function.prototype.bind.apply(_this2.Size, [null].concat(scaledSizeParams)))() }, optimized: !_this2.userAgentIsIE, locationKey: lat + '|' + lng, zIndex: data.type === 'agency' ? _this2.maxZIndex * 2 : _this2.maxZIndex += 1 }));};this.createDraggablePin = function (lat, lng) {return new _this2.Marker(Object.assign({ position: { lat: lat, lng: lng } }, _this2.userAgentIsIE ? {} : { icon: { url: _createCustomMapPin.draggablePin } }, { draggable: true, optimized: !_this2.userAgentIsIE }));};this.setDragEndListener = function (marker, callback) {var listener = _this2.event.addListener(marker, 'dragend', function () {callback(marker.getPosition().lat(), marker.getPosition().lng());});return listener;};this.toggleFavoriteIconAtPin = function (pin, isFavorite) {var type = isFavorite ? 'favorite' : 'property';pin.setOptions({ icon: { url: (0, _createCustomMapPin2.default)(0, type, pin.animated, pin.reviewed, _this2.userAgentIsFirefox), scaledSize: new _this2.Size(20, 20) }, optimized: !_this2.userAgentIsIE, type: type });};this.setReviewedIcon = function (pin) {var number = !pin.isProject && pin.ids && pin.ids.length || 0;pin.reviewed = true;pin.setOptions({ icon: { url: (0, _createCustomMapPin2.default)(number, pin.type, pin.animated, true, _this2.userAgentIsFirefox), scaledSize: new _this2.Size(20, 20) }, optimized: !_this2.userAgentIsIE });};this.addAnimationToPin = function (pin, number, type) {pin.setOptions({ optimized: false, zIndex: _this2.maxZIndex += 1 });pin.setIcon({ url: (0, _createCustomMapPin2.default)(number, type || pin.type, true, pin.reviewed, _this2.userAgentIsFirefox), scaledSize: new _this2.Size(20, 40) });pin.animated = true;};this.removeAnimationFromPin = function (pin, number, type) {pin.setOptions({ optimized: !_this2.userAgentIsIE, zIndex: _this2.maxZIndex += 1 });pin.setIcon({ url: (0, _createCustomMapPin2.default)(number, type || pin.type, false, pin.reviewed), scaledSize: new _this2.Size(20, 20) });pin.animated = false;};this.findPinInCluster = function (cluster, id) {return cluster.markers_.find(function (item) {return item.ids.indexOf(id) !== -1;});};this.clusterIsPropertyPin = function (pin) {return pin.markers_ && pin.map_ && pin.map_.zoom > _constants.mapDefaultOptions.clustererOptions.maxZoom;};this.setAnimatedIconToPin = function (pin, type, number, currentId) {if (type !== 'cluster') {_this2.addAnimationToPin(pin, number, type);} else if (_this2.clusterIsPropertyPin(pin)) {var animatedPin = _this2.findPinInCluster(pin, currentId);var pinNumber = animatedPin.ids && animatedPin.ids.length;_this2.addAnimationToPin(animatedPin, pinNumber);} else {var div = pin.clusterIcon_.div_;if (div) {var _div$childNodes = div.childNodes,img = _div$childNodes[0],txt = _div$childNodes[1];if (txt) {txt.style.display = 'none';}if (img) {img.style.height = '';img.src = (0, _createCustomMapPin2.default)(number, 'big', true, _this2.userAgentIsFirefox);}div.style.zIndex = 100;div.style.top = +div.style.top.replace('px', '') - 16 + 'px';}}};this.unsetAnimatedIconFromPin = function (pin, type, number, currentId) {if (type !== 'cluster') {_this2.removeAnimationFromPin(pin, number, type);} else if (_this2.clusterIsPropertyPin(pin)) {var animatedPin = _this2.findPinInCluster(pin, currentId);var pinNumber = animatedPin.ids && animatedPin.ids.length;_this2.removeAnimationFromPin(animatedPin, pinNumber);} else {var div = pin.clusterIcon_.div_;if (div) {var _div$childNodes2 = div.childNodes,img = _div$childNodes2[0];if (img) {img.src = (0, _createCustomMapPin2.default)(number, 'big');}div.style.zIndex = 99;div.style.top = +div.style.top.replace('px', '') + 16 + 'px';}}};this.coordinateToPoint = function (coordinate) {return { lat: coordinate.lat(), lon: coordinate.lng() };};this.coordinatesToPoints = function () {var coordinates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return coordinates.map(_this2.coordinateToPoint);};this.getDistanceBetweenCoordinates = function (p1, p2) {return Math.sqrt(Math.pow(p1.lon - p2.lon, 2) + Math.pow(p1.lat - p2.lat, 2));};this.createPolygon = function (coordinates) {return new _this2.Polygon(Object.assign({}, _constants.drawOnMapOptions, { paths: [coordinates.map(function (item) {return { lat: item[1], lng: item[0] };})] }));};this.convertCoordinatesToPolygon = function (pointCoordinates, map) {var polygon = new _this2.Polygon(Object.assign({}, _constants.drawOnMapOptions));var mapBounds = map.getBounds();var nePointInPixel = map.getProjection().fromLatLngToPoint(mapBounds.getNorthEast());var swPointInPixel = map.getProjection().fromLatLngToPoint(mapBounds.getSouthWest());var mapWidth = map.getDiv().clientWidth;var mapHeight = map.getDiv().clientHeight; // Trust Andrew that it works :)
    var polygonPath = pointCoordinates.map(function (item) {var ratioX = item[0] / mapWidth;var ratioY = item[1] / mapHeight;var pointLngOnMapInPixel = (nePointInPixel.x - swPointInPixel.x) * ratioX + swPointInPixel.x;var pointLatOnMapInPixel = (swPointInPixel.y - nePointInPixel.y) * ratioY + nePointInPixel.y;var pointInPixel = new _this2.Point(pointLngOnMapInPixel, pointLatOnMapInPixel);return map.getProjection().fromPointToLatLng(pointInPixel);});polygon.setPath(polygonPath);polygon.setMap(map);return polygon;};this.simplifyPolygon = function (polygonCoordArr) {var multiplier = 1000000;var shifted = polygonCoordArr.map(function (_ref13) {var lat = _ref13.lat,lon = _ref13.lon;return { x: lon * multiplier, y: lat * multiplier };});var simplified = (0, _simplifyJs2.default)(shifted, _constants.googleSdkConfig.polygonSimplificationTolerance);return simplified.map(function (_ref14) {var x = _ref14.x,y = _ref14.y;return [x / multiplier, y / multiplier];});};this.convertPolygonToBounds = function (polygon) {var polygonPath = polygon.getPath();var lowX = polygonPath.getAt(0).lat();var lowY = polygonPath.getAt(0).lng();var highX = polygonPath.getAt(1).lat();var highY = polygonPath.getAt(1).lng();polygonPath.forEach(function (item) {if (item.lat() < lowX) {lowX = item.lat();}if (item.lat() > highX) {highX = item.lat();}if (item.lng() < lowY) {lowY = item.lng();}if (item.lng() > highY) {highY = item.lng();}});return { east: highY, north: highX, south: lowX, west: lowY };};this.convertPolygonToArray = function (polygon) {var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var isArray = polygon[0].constructor === Array;if (!isArray) {result.push({ lat: polygon[1], lon: polygon[0] });} else {polygon.forEach(function (subpoly) {return _this2.convertPolygonToArray(subpoly, result);});}return result;};this.changeMapBounds = function (map, bounds) {return map.fitBounds(bounds);};this.changeMapZoom = function (map, center) {var zoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.mapDefaultOptions.zoom;map.panTo({ lat: center.lat, lng: center.lon });map.setZoom(zoom);};this.changeMapBoundsByViewport = function (map, _ref15) {var topright = _ref15.topright,bottomleft = _ref15.bottomleft;var bounds = { east: topright.lon, north: topright.lat, south: bottomleft.lat, west: bottomleft.lon };return _this2.changeMapBounds(map, bounds);};this.changeViewport = function (map, center, viewport, zoom) {return zoom ? _this2.changeMapZoom(map, center, zoom) : _this2.changeMapBoundsByViewport(map, viewport);};this.refreshMap = function (map) {var center = map.getCenter();_this2.trigger(map, 'resize');map.setCenter(center);};this.clearMapPinsOrPolygons = function (items) {return items.forEach(function (item) {return item.setMap(null);});};this.clusterCalculator = function (pins, index) {return { index: index, title: '', text: pins.reduce(function (prev, curr) {return prev + (curr.ids && curr.ids.length || curr.number || 0);}, 0) };};this.createPinClusterer = function (map) {var pins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var imagePath = arguments[2];var calculator = arguments[3];return new _this2.MarkerClusterer(map, pins, Object.assign({}, _constants.mapDefaultOptions.clustererOptions, { calculator: calculator || _this2.clusterCalculator, imagePath: imagePath || _constants.mapDefaultOptions.clustererOptions.imagePath }));};this.getBounds = function (locations) {var bounds = { lat: { min: locations[0].lat, max: locations[0].lat }, lon: { min: locations[0].lon, max: locations[0].lon } };for (var _iterator6 = locations, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {var _ref17;if (_isArray6) {if (_i6 >= _iterator6.length) break;_ref17 = _iterator6[_i6++];} else {_i6 = _iterator6.next();if (_i6.done) break;_ref17 = _i6.value;}var _ref16 = _ref17;var lat = _ref16.lat,lon = _ref16.lon;if (lat > bounds.lat.max) {bounds.lat.max = lat;}if (lat < bounds.lat.min) {bounds.lat.min = lat;}if (lon > bounds.lon.max) {bounds.lon.max = lon;}if (lon < bounds.lon.min) {bounds.lon.min = lon;}}return { east: bounds.lon.max, north: bounds.lat.max, south: bounds.lat.min, west: bounds.lon.min };};this.polygonContainsLocation = function (y, x, vs) {var inside = false;for (var i = 0, j = vs.length - 1; i < vs.length; i += 1, j = i) {var xi = vs[i][0];var yi = vs[i][1];var xj = vs[j][0];var yj = vs[j][1];var intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi; // eslint-disable-line eqeqeq
      if (intersect) inside = !inside;}return inside;};this.googlePolygonContainsLocation = function (lat, lng, poly) {var point = new _this2.Coordinate(lat, lng);return _this2.containsLocation(point, poly);};this.getMapOptions = function (type, isRtl) {switch (type) {case 'property':return Object.assign({}, _constants.mapDefaultOptions, { zoom: 15, zoomControl: false, mapTypeControl: false, scrollwheel: false, disableDoubleClickZoom: true, draggable: false, gestureHandling: 'none', draggableCursor: 'arrow', clickableIcons: false });case 'company':return Object.assign({}, _constants.mapDefaultOptions, { minZoom: 7, zoomControlOptions: { position: _this2.position.LEFT_TOP }, disableDoubleClickZoom: true });default:return Object.assign({}, _constants.mapDefaultOptions, { zoomControlOptions: { position: isRtl ? _this2.position.LEFT_BOTTOM : _this2.position.RIGHT_BOTTOM }, styles: [{ featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] }] });}};this.latRad = function (lat) {var sin = Math.sin(lat * Math.PI / 180);var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;};this.zoom = function (mapPx, worldPx, fraction) {return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);};this.getZoomByViewport = function (ne, sw, width, height) {var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _constants.mapDefaultOptions;var maxZoom = options.maxZoom || 21; // const globeWidth = options.GLOBE.WIDTH || 256;
    var globeHeigth = options.GLOBE.HEIGHT || 256;var latFraction = Math.abs((_this2.latRad(ne.lat) - _this2.latRad(sw.lat)) / Math.PI); // const lonDiff = ne.lon - sw.lon;
    // const lonFraction = ((lonDiff < 0) ? (lonDiff + 360) : lonDiff) / 360;
    var latZoom = _this2.zoom(height, globeHeigth, latFraction); // Discard the width calculation for now
    // const lngZoom = this.zoom(width, globeWidth, lonFraction);
    var result = Math.min(latZoom, maxZoom); // , lngZoom
    return Number.isNaN(result) ? 0 : result;};};exports.default = GoogleService;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/googleService.js
// module id = 140
// module chunks = 0